module.exports = __webpack_public_path__ + "static/media/DubaiW23-Bold.186f67b1.woff2";